module.exports = __webpack_public_path__ + "static/media/promo-image-fr.48f9a798.jpg";